import { useMutation } from '@tanstack/react-query';
import { updateSurveyAnswers } from 'services/backofficeIntegration/http/endpoints/surveyQuestions/updateSurveyAnswers';

export const useUpdateSurveyAnswers = (payload: Record<number, number>) => {
  return useMutation({
    mutationFn: () => updateSurveyAnswers.callEndpoint(payload)
  });
};
